import React, { useEffect, useRef, useState } from "react"
import { DropdownIcon } from "../icons"
import Overlay from "./overlay"
import "./styles.scss"

const RangeSlider = ({
  minVal,
  maxVal,
  step = 1,
  minLabel,
  minLabelHelperText,
  maxLabel,
  maxLabelHelperText,
  helperText,
  onChange,
  value,
  skipValue,
  size,
}) => {
  const [dropdown, setDropdown] = useState(false)
  const [activeVal, setActiveVal] = useState("1")

  const toggledropdown = () => {
    setDropdown(prev => !prev)
  }

  const resizeRef = useRef(null)
  const sliderRef = useRef(null)

  const [barWidth, setBarWidth] = useState(0)

  let percentage = 0
  let leftPosition = 0
  if (sliderRef.current) {
    percentage = ((value - minVal) / (maxVal - minVal)) * 100
    leftPosition = (barWidth / 100) * percentage
  }

  const calculateBarWidth = () => {
    if (sliderRef.current) {
      const { width: barWidth } = sliderRef.current.getBoundingClientRect()
      setBarWidth(barWidth)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", () => {
      calculateBarWidth()
    })
    calculateBarWidth()
  }, [])

  const resizeHandler = e => {
    if (!resizeRef.current) return

    const xInbar = e.clientX - resizeRef.current.barXPosition
    const percentInBar = (xInbar / resizeRef.current.barWidth) * 100

    const newValue = ((maxVal - minVal) * percentInBar) / 100 + minVal
    let snapVal = Math.round(newValue / step) * step

    if (snapVal < minVal) {
      snapVal = minVal
    }
    if (snapVal > maxVal) {
      snapVal = maxVal
    }

    onChange(snapVal)
  }

  const resizeStartHandler = e => {
    if (!sliderRef.current) return
    const {
      width: barWidth,
      left: barXPosition,
    } = sliderRef.current.getBoundingClientRect()
    resizeRef.current = {
      clientX: e.clientX,
      value,
      barWidth,
      barXPosition,
    }
    const mouseUpHandler = () => {
      document.removeEventListener("mousemove", resizeHandler)
      document.removeEventListener("mouseup", mouseUpHandler)
    }
    document.addEventListener("mousemove", resizeHandler)
    document.addEventListener("mouseup", mouseUpHandler)
  }

  let ddData = []
  if (skipValue) {
    for (
      let i = minVal;
      i <= maxVal + Number(skipValue);
      i += Number(skipValue)
    ) {
      if (i === 1) {
        ddData.push(i)
      } else {
        ddData.push(i - 1)
      }
    }
  } else {
    for (let i = minVal; i <= maxVal; i++) {
      ddData.push(i)
    }
  }

  return (
    <div className="slider-parent">
      <div
        className={`slider-bar ${size === "small" ? "small" : ""}`}
        ref={sliderRef}
      >
        <div className="bar-active" style={{ width: `${percentage}%` }}></div>
        <div
          onMouseDown={resizeStartHandler}
          style={{
            transform: `translate(calc(${leftPosition}px - 50%), -50%)`,
          }}
          className="slider-cursor-div"
        >
          <div className="slider-cursor"></div>
          <div className="active-val">{`${value}${
            helperText ? helperText : ""
          }`}</div>
        </div>
      </div>
      <div className="values-div">
        <div className="w-16 text-left">
          <p>{minLabel}</p>
          {minLabelHelperText && (
            <p className="helperText">{minLabelHelperText}</p>
          )}
        </div>
        <div className="w-16 text-right">
          <p>{maxLabel}</p>
          {maxLabelHelperText && (
            <p className="helperText">{maxLabelHelperText}</p>
          )}
        </div>
      </div>

      <Overlay
        className={`dropdown_overlay ${dropdown ? "active" : ""}`}
        onClick={() => setDropdown(false)}
      />
      <div className={`dd__opener ${dropdown ? "active" : ""}`}>
        <button className={`selected__value `} onClick={toggledropdown}>
          <span className="text">{activeVal}</span>
          <span className="drodpown">
            <DropdownIcon />
          </span>
        </button>
      </div>
      <div className={`md:hidden dropdown ${dropdown ? "active" : ""}`}>
        {ddData.map(item => {
          return (
            <button
              className="dd__value"
              onClick={() => {
                setActiveVal(item)
                onChange(item)
                toggledropdown()
              }}
            >
              {item}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default RangeSlider
